module.exports = __webpack_public_path__ + "img/price-icon-neo-qled.f36eb66b.png";